import { createAsyncAction } from 'typesafe-actions';
import { LoyaltyRewardsReducer } from '../types/reducer';

export const FETCH_LOYALTY_REWARDS = createAsyncAction(
  'loyaltyRewards/FETCH_LOYALTY_REWARDS/request',
  'loyaltyRewards/FETCH_LOYALTY_REWARDS/success',
  'loyaltyRewards/FETCH_LOYALTY_REWARDS/failure',
  'loyaltyRewards/FETCH_LOYALTY_REWARDS/cancel',
)<null, LoyaltyRewardsReducer.ILoyaltyReward | null, Error, void>();
